import TealiumUniversalTag from '@nib/tealium-universal-tag';
import { account, environment, profile } from '../../tealiumConfig';

export type TealiumTrack = (eventName: string, eventData: Record<string, unknown>) => void;
export type TealiumPageView = (eventName: string, params?: Record<string, unknown>) => void;

type TealiumWrapper = {
  tealiumTrack: TealiumTrack;
  tealiumPageView: TealiumPageView;
};

export const tealiumWrapper = (): TealiumWrapper => {
  const tealiumInstance = new TealiumUniversalTag({
    account,
    environment,
    profile,
    manualPageView: true
  });

  const tealiumTrack: TealiumTrack = (eventName: string, eventData: Record<string, unknown>): void => {
    if (tealiumInstance && typeof tealiumInstance.track === 'function') {
      tealiumInstance.track(eventName, eventData);
    }
  };

  const tealiumPageView: TealiumPageView = (eventName: string, params?: Record<string, unknown>): void => {
    if (tealiumInstance && typeof tealiumInstance.pageView === 'function') {
      tealiumInstance.pageView(eventName, params);
    }
  };

  return {
    tealiumTrack,
    tealiumPageView
  };
};
